<template lang="pug">
	div(v-if="ready")
		.path.breadcrumbs(itemscope itemtype="http://schema.org/BreadcrumbList")
			span.breadcrumb-element(v-for="(element, index) of breadcrumbsList" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem")
				a(:href="element.href || element.url || null" itemprop="item")
					span(itemprop="name")
						| {{element.name}}
				meta(itemprop="position" :content="index + 1")
				span.arrow(v-if="index != (breadcrumbsList.length - 1)")
					| &nbsp;&#62;&nbsp;
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
.breadcrumbs
	margin-bottom 15px
	white-space: nowrap
	overflow: hidden
	text-overflow: ellipsis
	padding: 0 15px 0 0
	margin-top: 45px
	width: 100%
	> span
		display: inline-block
		> a
			color: body-font-color
			font-size: body-font-size-xs
			text-decoration: none !important
			&:hover
				color: body-font-color !important
				text-decoration: underline !important
		&:last-child
			a
				text-decoration: none !important
				cursor: default !important

	.arrow
		position: absolute
		top: 3px
		font-size: body-font-size-xs
		right: 2px

	.breadcrumb-element
		position: relative
		padding-right: 15px



</style>

<script>
	export default {
		props:[
			'breadcrumbsList'
		],
		data(){
			return {
				ready: true
			}
		}
	}
</script>
